(() => {
  const shuffle = nodes => {
    for (let i = nodes.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [nodes[i], nodes[j]] = [nodes[j], nodes[i]];
    }
    return nodes;
  };
  const reorder = (parent, nodes) => {
    if (nodes.length < 2) return;
    shuffle(nodes);
    const stock = node => (node.dataset.available || node.querySelector('product-card')?.dataset.vdAvailable) !== 'false';
    const vendor = node => (node.dataset.vendor || node.querySelector('product-card')?.dataset.vdVendor || '').trim().toLocaleLowerCase('tr');
    const ordered=[];
    let previous='';
    for(const available of [true,false]){
      const groups=new Map();
      for(const node of nodes.filter(node=>stock(node)===available)){
        const key=vendor(node);if(!groups.has(key))groups.set(key,[]);groups.get(key).push(node);
      }
      while(groups.size){
        const entries=[...groups.entries()].sort((a,b)=>b[1].length-a[1].length);
        const selected=entries.find(([key])=>key!==previous)||entries[0];
        ordered.push(selected[1].shift());previous=selected[0];if(!selected[1].length)groups.delete(selected[0]);
      }
    }
    ordered.forEach(node => { node.dataset.vdShuffled = 'true'; parent.append(node); });
  };
  const shuffleLists = () => {
    document.querySelectorAll('[data-vd-shuffle-products]').forEach(root => {
      root.querySelectorAll('.resource-list').forEach(list => {
        const carousel = list.classList.contains('resource-list__carousel') ? list.querySelector(':scope > div > slideshow-component') : null;
        const scroller = carousel?.querySelector(':scope > slideshow-container > slideshow-slides');
        [scroller].filter(Boolean).forEach(scroller => {
          if (scroller.dataset.vdShuffled) return;
          const slides = Array.from(scroller.children).filter(el => el.tagName === 'SLIDESHOW-SLIDE');
          reorder(scroller, slides);
          scroller.dataset.vdShuffled = 'true';
        });
        if (list.classList.contains('resource-list--grid') && !list.dataset.vdShuffled) {
          reorder(list, Array.from(list.children).filter(el => el.classList.contains('resource-list__item')));
          list.dataset.vdShuffled = 'true';
        }
      });
    });
    document.querySelectorAll('vd-stock-results[data-search-performed="false"] .product-grid:not([data-vd-shuffled])').forEach(grid=>{reorder(grid,Array.from(grid.children).filter(el=>el.matches('[data-product-id]')));grid.dataset.vdShuffled='true';});
    if (new URL(location.href).searchParams.has('sort_by')) return;
    document.querySelectorAll('[data-vd-shuffle-collection] .product-grid').forEach(grid => {
      const pages = new Map();
      Array.from(grid.children).filter(el => el.matches('.product-grid__item[data-product-id]:not([data-vd-shuffled])')).forEach(el => {
        const key = el.dataset.page || '1';
        if (!pages.has(key)) pages.set(key, []);
        pages.get(key).push(el);
      });
      pages.forEach(nodes => reorder(grid, nodes));
    });
  };
  const updateDaily = () => {
    const day = Math.floor((Date.now() + 10800000) / 86400000);
    document.querySelectorAll('[data-vd-daily]').forEach(root => {
      const pool = root.querySelector('[data-vd-daily-pool]');
      const grid = root.querySelector('[data-vd-daily-grid]');
      const products = Array.from(pool?.content.children || []);
      if (!products.length || !grid) return;
      const groups = new Map();
      products.forEach(product => {
        const vendor = (product.dataset.vdDailyVendor || '').trim().toLowerCase();
        if (!groups.has(vendor)) groups.set(vendor, []);
        groups.get(vendor).push(product);
      });
      const vendors = Array.from(groups.keys());
      const firstIndex = (day * 2) % vendors.length;
      const secondIndex = (firstIndex + 1) % vendors.length;
      const cycle = Math.floor((day * 2) / vendors.length);
      const first = groups.get(vendors[firstIndex]);
      const second = groups.get(vendors[secondIndex]);
      const selected = [first[cycle % first.length]];
      if (firstIndex !== secondIndex) selected.push(second[cycle % second.length]);
      if (Array.from(grid.children).map(el => el.dataset.vdDailyProduct).join() !== selected.map(el => el.dataset.vdDailyProduct).join()) {
        grid.replaceChildren(...selected.map(el => el.cloneNode(true)));
      }
      root.dataset.vdDay = String(day);
    });
  };
  const run = () => { shuffleLists(); updateDaily(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('pageshow', event => { if (event.persisted) run(); });
  let queued = false;
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(records => {
    const relevant = records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('results-list, .product-grid__item, [data-vd-shuffle-products]') || node.querySelector?.('[data-vd-shuffle-products], [data-vd-shuffle-collection]'))));
    if (!relevant || queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; run(); });
  }).observe(main, { childList: true, subtree: true });
  const untilMidnight = 86400000 - ((Date.now() + 10800000) % 86400000);
  setTimeout(() => { updateDaily(); setInterval(updateDaily, 86400000); }, untilMidnight + 500);
})();
